import styled from "styled-components";

export const ContainerReport = styled.div`
  background-color: ${({ theme }) => theme.neutral.white};
  padding: 1rem 2rem;
  width: 92vw;
`;

export const ButtonDownload = styled.button`
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  border: none;
  margin: 0px auto;
`;

export const TitleReport = styled.span`
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  border: none;
  margin: auto;
`;

export const ContainerHead = styled.div`
  display: grid;
  grid-template-columns: 16vw 55vw 16vw;
`;
export const ContentSurveyRating = styled.div`
  width: 42em;
  margin: auto;
  height: 16em;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 11em 3em;
  background: ${({ theme }) => theme.background.light};
  margin-top: 1em;
  padding: 1em;
  text-align: center;
  @media only screen and (max-width: 480px) {
    width: 100%;
    grid-template-columns: 1fr;
    padding: 0;
  }
`;
export const BtnDownloadSurveyRating = styled.button`
  background: ${({ theme }) => theme.button.primary};
  margin: auto;
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 11em;
  height: 43.21px;
  padding: 4px 0;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ContentDownloadFile = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const TextDownloadFile = styled.span`
  text-decoration: none;
  color: ${({ theme }) => theme.neutral.black};
  &:hover {
    text-decoration: underline;
  }
`;
